import React, { useEffect, useRef, useState } from "react";


function Ukimport() {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = useRef([]);
  const contentRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    sectionRefs.current = sectionRefs.current.slice(0, 10);

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = sectionRefs.current.indexOf(entry.target);
          setActiveIndex(index);
        }
      });
    }, observerOptions);

    sectionRefs.current.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const scrollToSection = (index) => {
    setActiveIndex(index);
    const section = sectionRefs.current[index];
    const contentElement = contentRef.current;

    const scrollPosition = section.offsetTop - contentElement.offsetTop;

    contentElement.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="flex flex-wrap">
        <div className="flex flex-col items-center justify-center px-4 py-7 md:justify-between md:px-20 xl:flex-row"></div>

        <div className="mb-20 flex min-h-screen">
          <div
            ref={titleRef}
            className="sticky top-20 hidden h-screen w-1/4 overflow-y-auto bg-gray-100 p-4 md:block"
          >
            <ul className="space-y-2">
              <li
                onClick={() => scrollToSection(0)}
                className={`cursor-pointer p-12 ${
                  activeIndex === 0
                    ? "bg-blue-500 text-white"
                    : "bg-white text-[#2C3F69]"
                } shadow rounded-md`}
              >
                Tier 1 Visa
              </li>
              <li
                onClick={() => scrollToSection(1)}
                className={`cursor-pointer p-12 ${
                  activeIndex === 1
                    ? "bg-blue-500 text-white"
                    : "bg-white text-[#2C3F69]"
                } shadow rounded-md`}
              >
                Tier 2 Visa
              </li>
              <li
                onClick={() => scrollToSection(2)}
                className={`cursor-pointer p-12 ${
                  activeIndex === 2
                    ? "bg-blue-500 text-white"
                    : "bg-white text-[#2C3F69]"
                } shadow rounded-md`}
              >
                Tier 3 Visa
              </li>
              <li
                onClick={() => scrollToSection(3)}
                className={`cursor-pointer p-12 ${
                  activeIndex === 3
                    ? "bg-blue-500 text-white"
                    : "bg-white text-[#2C3F69]"
                } shadow rounded-md`}
              >
                Tier 4 Visa
              </li>
              <li
                onClick={() => scrollToSection(4)}
                className={`cursor-pointer p-12 ${
                  activeIndex === 4
                    ? "bg-blue-500 text-white"
                    : "bg-white text-[#2C3F69]"
                } shadow rounded-md`}
              >
                Tier 5 Visa
              </li>
              <li
                onClick={() => scrollToSection(5)}
                className={`cursor-pointer p-12 ${
                  activeIndex === 5
                    ? "bg-blue-500 text-white"
                    : "bg-white text-[#2C3F69]"
                } shadow rounded-md`}
              >
                Visitor Visa
              </li>
              <li
                onClick={() => scrollToSection(6)}
                className={`cursor-pointer p-12 ${
                  activeIndex === 6
                    ? "bg-blue-500 text-white"
                    : "bg-white text-[#2C3F69]"
                } shadow rounded-md`}
              >
                UK Family Visa
              </li>
              <li
                onClick={() => scrollToSection(7)}
                className={`cursor-pointer p-12 ${
                  activeIndex === 7
                    ? "bg-blue-500 text-white"
                    : "bg-white text-[#2C3F69]"
                } shadow rounded-md`}
              >
                UK Business Visa
              </li>
            </ul>
          </div>

          <div
            ref={contentRef}
            className="mb-10 h-screen overflow-y-auto p-4 md:w-3/4 lg:w-3/4 xl:w-3/4"
          >
            {/* Tier 1 Visa */}
            <div ref={(el) => (sectionRefs.current[0] = el)}>
              <p className="text-3xl font-bold text-[#011473]">Tier 1 Visa</p>
              <p className="mt-4 text-[#2C3F69]">
                This visa is intended for individuals with extraordinary talent
                or substantial financial means, enabling entrepreneurs and
                investors to start or grow their business in the UK.
              </p>
              <p className="mt-4 text-[#2C3F69] font-semibold">Required Documents:</p>
              <ul className="list-disc text-[#2C3F69] pl-6">
                <li>Current passport</li>
                <li>Bank statement showing at least £2,000,000</li>
                <li>Clear tuberculosis test result</li>
                <li>Criminal record check</li>
              </ul>
            </div>

            {/* Tier 2 Visa */}
            <div ref={(el) => (sectionRefs.current[1] = el)} className="mt-10">
              <p className="text-3xl font-bold text-[#011473]">Tier 2 Visa</p>
              <p className="mt-4 text-[#2C3F69]">
                Designed for skilled workers, this visa allows individuals
                sponsored by UK employers to work in roles with a high demand for
                expertise.
              </p>
              <p className="mt-4 text-[#2C3F69] font-semibold">Required Documents:</p>
              <ul className="list-disc text-[#2C3F69] pl-6">
                <li>Proof of English language skills</li>
                <li>Valid passport and travel details</li>
                <li>Evidence of financial means to support living expenses</li>
                <li>Sponsorship letter from employer</li>
              </ul>
            </div>

            {/* Tier 3 Visa */}
            <div ref={(el) => (sectionRefs.current[2] = el)} className="mt-10">
              <p className="text-3xl font-bold text-[#011473]">Tier 3 Visa</p>
              <p className="mt-4 text-[#2C3F69]">
                The Tier 3 visa was previously available for lower-skilled
                workers but is no longer issued by the UK government.
              </p>
            </div>

            {/* Tier 4 Visa */}
            <div ref={(el) => (sectionRefs.current[3] = el)} className="mt-10">
              <p className="text-3xl font-bold text-[#011473]">Tier 4 Visa</p>
              <p className="mt-4 text-[#2C3F69]">
                This visa allows students from overseas to study at accredited
                institutions in the UK on a full-time basis.
              </p>
              <p className="mt-4 text-[#2C3F69] font-semibold">Required Documents:</p>
              <ul className="list-disc text-[#2C3F69] pl-6">
                <li>Proof of English language proficiency</li>
                <li>Acceptance letter from a UK educational institution</li>
                <li>Financial evidence covering tuition and living costs</li>
              </ul>
            </div>

            {/* Tier 5 Visa */}
            <div ref={(el) => (sectionRefs.current[4] = el)} className="mt-10">
              <p className="text-3xl font-bold text-[#011473]">Tier 5 Visa</p>
              <p className="mt-4 text-[#2C3F69]">
                For temporary workers, including those in cultural exchange or
                youth mobility programs, this visa allows for short-term work
                opportunities in the UK.
              </p>
              <p className="mt-4 text-[#2C3F69] font-semibold">Required Documents:</p>
              <ul className="list-disc text-[#2C3F69] pl-6">
                <li>Current passport</li>
                <li>Proof of financial support</li>
                <li>Sponsorship documents</li>
              </ul>
            </div>

            {/* Visitor Visa */}
            <div ref={(el) => (sectionRefs.current[5] = el)} className="mt-10">
              <p className="text-3xl font-bold text-[#011473]">Visitor Visa</p>
              <p className="mt-4 text-[#2C3F69]">
                This short-term visa is for travelers visiting the UK for
                tourism, business meetings, or medical treatments for up to six
                months.
              </p>
              <p className="mt-4 text-[#2C3F69] font-semibold">Required Documents:</p>
              <ul className="list-disc text-[#2C3F69] pl-6">
                <li>Current passport</li>
                <li>Travel itinerary and accommodation details</li>
                <li>Proof of financial means for the trip</li>
              </ul>
            </div>

            {/* UK Family Visa */}
            <div ref={(el) => (sectionRefs.current[6] = el)} className="mt-10">
              <p className="text-3xl font-bold text-[#011473]">UK Family Visa</p>
              <p className="mt-4 text-[#2C3F69]">
                This visa is designed for individuals wishing to reunite with
                family members residing in the UK, such as spouses, children, or
                dependents.
              </p>
              <p className="mt-4 text-[#2C3F69] font-semibold">Required Documents:</p>
              <ul className="list-disc text-[#2C3F69] pl-6">
                <li>Proof of relationship (e.g., marriage certificate)</li>
                <li>Valid passport</li>
                <li>Evidence of financial support</li>
              </ul>
            </div>

            {/* UK Business Visa */}
            <div ref={(el) => (sectionRefs.current[7] = el)} className="mt-10">
              <p className="text-3xl font-bold text-[#011473]">UK Business Visa</p>
              <p className="mt-4 text-[#2C3F69]">
                This visa is for business professionals traveling to the UK for
                business purposes, such as attending meetings, conferences, or
                setting up business operations.
              </p>
              <p className="mt-4 text-[#2C3F69] font-semibold">Required Documents:</p>
              <ul className="list-disc text-[#2C3F69] pl-6">
                <li>Valid passport</li>
                <li>Proof of business-related travel (e.g., invitation letter)</li>
                <li>Evidence of financial support</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

     

    </>
  );
}

export default Ukimport;
